import _typeof from "@babel/runtime/helpers/typeof";
import { CEXP_LOADED, CEXP_PROVIDER_LOADED } from '../constants';
export var sendProviderLoadedMessageToParent = function sendProviderLoadedMessageToParent() {
  window.parent.postMessage(CEXP_PROVIDER_LOADED, '*');
};
export var sendConfirmLoadedSdkToProvider = function sendConfirmLoadedSdkToProvider(childIframe) {
  var _childIframe$contentW;
  (_childIframe$contentW = childIframe.contentWindow) === null || _childIframe$contentW === void 0 || _childIframe$contentW.postMessage(CEXP_LOADED, '*');
};
export function isSdkMessage(value) {
  if (_typeof(value) !== 'object' || value === null) {
    return false;
  }
  var _ref = value,
    type = _ref.type,
    payload = _ref.payload;
  return typeof type === 'string' && (type === 'completed' || type === 'errored') && payload !== undefined;
}